export const RIGHTS_HOLDER_TYPE = 'rights_holder'
export const PARTNER_TYPE = 'partner'

export const MANAGER = 'manager'
export const ADMIN = 'admin'
export const REPORT = 'report'
